import React from 'react';
import { StatusType } from '../types.js';

export interface StatusIndicatorProps {
  className?: string;
  type: 'ml' | 'alert' | 'system';
  status: StatusType;
  size?: 'sm' | 'md' | 'lg';
  animate?: boolean;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  className = '',
  type: type,
  status,
  size = 'md',
  animate = false,
}) => {
  const getStatusColor = (status: StatusType): string => {
    switch (status) {
      case 'active':
        return 'bg-green-500';
      case 'inactive':
        return 'bg-gray-400';
      case 'warning':
        return 'bg-yellow-500';
      case 'error':
        return 'bg-red-500';
      case 'resolved':
        return 'bg-blue-500';
      case 'investigating':
        return 'bg-purple-500';
      case 'running':
        return 'bg-cyan-500';
      default:
        return 'bg-gray-400';
    }
  };

  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  return (
    <span
      className={`
        inline-block rounded-full ${sizeClasses[size]} ${getStatusColor(status)}
        ${animate ? 'animate-pulse' : ''} ${className}
      `}
    />
  );
};

export default StatusIndicator;
